export const YES_SELECTED = 'YES_SELECTED';
export const NO_SELECTED = 'NO_SELECTED';

export const VALIDATION_ERROR_SET = 'VALIDATION_ERROR_SET';
export const VALIDATION_ERROR_CLEAR = 'VALIDATION_ERROR_CLEAR';
export const VALIDATION_ERROR_SCROLL = 'VALIDATION_ERROR_SCROLL';

export const ADD_MEDICATION = 'ADD_MEDICATION';